import { render, staticRenderFns } from "./edit-insurance-visa.vue?vue&type=template&id=289adc73&"
import script from "./edit-insurance-visa.vue?vue&type=script&lang=js&"
export * from "./edit-insurance-visa.vue?vue&type=script&lang=js&"
import style0 from "./edit-insurance-visa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports